module.exports = __webpack_public_path__ + "static/media/messenger.360a5080.svg";